import { useState, useCallback, useEffect } from 'react'
import { isSmallDevice } from '../../utils/deviceScreen'
import { List } from 'phosphor-react'

import styles from './styles.module.css'
import ProfileInfo from '../ProfileInfo'

function NavTop({
  user,
  handleCollapsedChange,
  handleToggleSidebar,
  toggled,
  collapsed,
  pageName,
}) {
  const [isSmallWidth, setIsSmallWidth] = useState(() => {
    const checkScreenWidth = isSmallDevice()

    return checkScreenWidth
  })

  const updateShowMenu = useCallback(() => {
    const checkScreenWidth = isSmallDevice()
    setIsSmallWidth(checkScreenWidth)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateShowMenu)
    return () => {
      window.removeEventListener('resize', updateShowMenu)
    }
  })
  return (
    <div>
      <div className={isSmallWidth ? styles.smallScreenContainer : styles.container}>
        <div className="d-flex flex-row align-items-center">
          <div
            className={styles.icon}
            onClick={() =>
              isSmallWidth ? handleToggleSidebar(!toggled) : handleCollapsedChange(!collapsed)
            }
          >
            <List weight="bold" color="#FFFFFF" size={20} />
          </div>
          <p className={styles.title}>{pageName || ''}</p>
        </div>
        {!isSmallWidth && <ProfileInfo user={user} userCircleColor="white" />}
      </div>
    </div>
  )
}

export default NavTop
